<template>
  <div class="account">
    <div class="account-content">
      <account-filter :platType="2" ref="filterDataRef" @searchData="getDataList"></account-filter>
      <account-table :platType="2" ref="accountTableRef" :tableData="tableData" @refrushList="getDataList"></account-table>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        @getCurrentPage="getCurrentPage"
        @handleSizeChange="getCurrentSize"
        ref="tabelPagination"
      ></self-pagination>
    </div>
  </div>
</template>
<script>
import AccountFilter from "../components/domesticFilter.vue";
import AccountTable from "../components/domesticTable.vue";
import launchServer from "@/api/account-management";
export default {
  name: "ads",
  components: { AccountFilter, AccountTable },
  data() {
    return {
      tableData: [],
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
    };
  },
  mounted() {
    this.tableData = [];
    this.pageData.page = 1;
    this.getDataList();
  },
  methods: {
    getDataList() {
      let parmas = this.$refs.filterDataRef.getFormatData();
      Object.assign(parmas, {
        size: this.pageData.size,
        page: this.pageData.page,
        platType: 2,
      });
      launchServer.getAdvertiserInfo(parmas).then((res) => {
        if (res.code === "0000") {
          this.tableData = res.advertiseInfos || [];
          this.pageData.total = res.totalCount;
        }
      });
    },
    getCurrentPage(page) {
      this.pageData.page = page;
      this.getDataList();
    },
    getCurrentSize (size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getDataList();
    }
  },
};
</script>

<style lang="less" scoped>
.account {
  display: flex;
  height: 100%;
  .account-sider {
    flex: 1;
  }
  .account-content {
    width: 100%;
  }
}
</style>
